import { useEffect, useRef } from 'react';

const EVENT = 'dlv-employee-activity-changed';
export const notifyEmployeeActivityChange = () => {
  window.dispatchEvent(new Event(EVENT));
  try { localStorage.setItem(EVENT, `${Date.now()}-${Math.random()}`); } catch (_) { /* Refresh on focus remains available. */ }
};

export const useEmployeeActivityRefresh = (refresh) => {
  const latest = useRef(refresh);
  latest.current = refresh;
  useEffect(() => {
    let timer;
    const schedule = () => {
      clearTimeout(timer);
      timer = setTimeout(() => latest.current(), 100);
    };
    const storage = event => { if (event.key === EVENT) schedule(); };
    const visible = () => { if (document.visibilityState === 'visible') schedule(); };
    window.addEventListener(EVENT, schedule);
    window.addEventListener('storage', storage);
    window.addEventListener('focus', schedule);
    document.addEventListener('visibilitychange', visible);
    return () => {
      clearTimeout(timer);
      window.removeEventListener(EVENT, schedule);
      window.removeEventListener('storage', storage);
      window.removeEventListener('focus', schedule);
      document.removeEventListener('visibilitychange', visible);
    };
  }, []);
};